// extracted by mini-css-extract-plugin
export var sliderRange = "_q4-2";
export var sliderRoot = "_q4-0";
export var sliderThumb = "_q4-3";
export var sliderTrack = "_q4-1";